import { filter } from 'lodash';

import { HAS_INSTANT_DISCOUNT } from '../constants';

import { getParityTotal } from './index';

export const incrementItemCart = (cart, item, nextQuantity) =>
    cart.map(object => {
        if (item.facialValue !== object.facialValue) return object;
        return {
            ...object,
            quantityQuery: nextQuantity || item.quantityQuery + object.quantityQuery
        };
    });

export const findCartItem = (item, cart) =>
    cart.find(({ facialValue }) => facialValue === item.facialValue);

export const filterCartItem = (item, cart) =>
    cart.filter(
        ({ quantityQuery, facialValue }) =>
            quantityQuery !== item.quantityQuery || facialValue !== item.facialValue
    );

export const doCartTotal = cart =>
    cart.reduce((acc, curr) => acc + curr.quantityQuery * curr.facialValue, 0);

export const doCartTotalTtc = (cart, amountCashback) => {
    const cartTotal = cart.reduce((acc, curr) => acc + curr.quantity * curr.value, 0);

    if (!HAS_INSTANT_DISCOUNT) {
        return cartTotal;
    } else {
        const totalCashbackAmount = (cartTotal * (100 - amountCashback)) / 100;
        const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
        return normalizedCashBackNumber;
    }
};

export const doUserCartTotalCashbackAmount = (cart, amountCashback) => {
    const cartTotal = cart.reduce((acc, curr) => acc + curr.quantity * curr.value, 0);
    const cashback = (cartTotal * (100 - amountCashback)) / 100;
    return Number((cartTotal - cashback).toFixed(2));
};

export const doUserCartTotalCashbackAmountParity = (cart, amountCashback) => {
    const cartTotal = cart.reduce((acc, curr) => acc + curr.quantity * curr.value, 0);
    const totalCashbackAmount = getParityTotal(cartTotal, amountCashback);
    const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
    return normalizedCashBackNumber;
};

export const findCartTotalQuantity = cart =>
    cart.reduce((acc, curr) => acc + curr.quantityQuery, 0);

export const mapPartner = (cart, partners) => {
    if (cart.length > 0) {
        return filter(partners, p => p.id === cart[0].partnerId)[0];
    }
    return undefined;
};

export const mapUserCart = (cart, partners) => {
    if (cart.length > 0) {
        const partner = filter(partners, p => p.id === cart[0].partnerId)[0];
        return cart.map(item => {
            return {
                quantity: item.quantityQuery,
                partnerName: partner.name,
                value: item.facialValue
            };
        });
    }
    return [];
};

/* Ebon selector */
export const doDiscount = (amountCashback, quantity, value) => {
    const selectedTotal = Number(quantity * value);
    const totalCashbackAmount = (selectedTotal * (100 - amountCashback)) / 100;
    const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
    return Number((selectedTotal - normalizedCashBackNumber).toFixed(2));
};

export const doDiscountParity = (amountCashback, quantity, value) => {
    const selectedTotal = Number(quantity * value);
    const totalCashbackAmount = getParityTotal(selectedTotal, amountCashback);
    const normalizedCashBackNumber = Number(totalCashbackAmount.toFixed(2));
    return normalizedCashBackNumber;
};



// WEBPACK FOOTER //
// ./src/utils/cartUtils.js